/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
export const OrganizationNameRouteParam = 'organizationName';
